import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

interface UserRolesState {
  data: string[]
}

const initialState: UserRolesState = {
  data: [],
}

const UserRolesSlice = createSlice({
  name: 'userRoles',
  initialState,
  reducers: {
    // Replace all roles
    setRoles: (state, action: PayloadAction<string[]>) => {
      state.data = action.payload
    },

    // Add a new role if not already present
    addRole: (state, action: PayloadAction<string>) => {
      if (!state.data.includes(action.payload)) {
        state.data.push(action.payload)
      }
    },

    // Remove a role
    removeRole: (state, action: PayloadAction<string>) => {
      state.data = state.data.filter((role) => role !== action.payload)
    },

    // Clear all roles
    clearRoles: (state) => {
      state.data = []
    },
  },
})

// Selectors
export const selectUserRoles = (state: { userRoles: UserRolesState }) =>
  state?.userRoles?.data

export const selectHasUserRole =
  (role: string) => (state: { userRoles: UserRolesState }) =>
    state?.userRoles?.data?.includes(role)

export const { setRoles, addRole, removeRole, clearRoles } =
  UserRolesSlice.actions

export default UserRolesSlice.reducer
